module.exports = __webpack_public_path__ + "static/img/08.1e83a926.png";